import axios from "@/api/axiosInstance";
import {
  UpdateDashboardChartConfigRequest,
  UpdateDashboardChartConfigResponse,
} from "./types";

export const updateDashboardChartConfig = async (
  stageUuid: string,
  requestData: UpdateDashboardChartConfigRequest,
): Promise<UpdateDashboardChartConfigResponse> => {
  const response = await axios.put<UpdateDashboardChartConfigResponse>(
    `/api/private/administration/stochastic/dashboard-chart-configs/${stageUuid}`,
    requestData,
  );
  return response.data;
};
